import React from "react";

const EditedTag = () => {
  return (
    <span
      style={{
        position: "absolute",
        right: 5,
        bottom: 5,
        fontSize: 12,
        backgroundColor:"grey",
      }}
      className="text-white px-1 rounded"
    >
      Edited
    </span>
  );
};

export default EditedTag;
